import React from "react";
import { useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { CustomText } from "../../../components/CustomText";

import { GetGoalById } from "../../../api/api.service";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { hasData } from "../../../utils/commonUtils";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";
import GoalTypes from "../../../constants/GoalTypes";
import GoalStatus from "../../../constants/GoalStatus";
import GoalChip from "../../UserManagement/GoalChip";

const GoalDetails = () => {
    const location = useLocation();

    const id = location.pathname.split("/").pop();

    let { useFetch } = useRequestProcessor();
    const { data, isLoading, isFetching } = useFetch(
        getKey([MODULE_KEYS.GOAL_DETAILS], { id }),
        async ({ signal }) =>
            await GetGoalById({
                id: id
            })
    );

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <Container fluid className="py-4 goal-detail-container ">
            <Row className="mb-2">
                <Col md={3}>
                    <CustomText
                        title={"Goal Name"}
                        description={data?.name || "-"}
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
                <Col md={2}>
                    <CustomText
                        title={"Goal Type"}
                        description={GoalTypes.getDisplayTextKey(data?.type) || "-"}
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
                <Col md={2}>
                    <CustomText
                        titleClass="label-classes"
                        descClass="desc-classes"
                        description={data?.priorityNumber || "-"}
                        title={"Goal Order"}
                    />
                </Col>

                <Col md={2}>
                    <CustomText
                        titleClass="label-classes"
                        descClass={`  ${
                            data?.status ? "status-common-class" : ""
                        } ${GoalStatus.getLabelClass(data?.status)}`}
                        title={"Goal"}
                        description={GoalStatus.getDisplayTextKey(data?.status) || "N/A"}
                    />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={12}>
                    <CustomText
                        title={"Sub Category"}
                        description={
                            <div className="d-flex flex-wrap gap-2">
                                {data?.goalLabels?.map((goal, index) => (
                                    <GoalChip key={index} label={goal?.label?.title} />
                                ))}
                            </div>
                        }
                        titleClass="label-classes mb-2"
                        descClass="desc-classes"
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default GoalDetails;
